import { render, staticRenderFns } from "./round-ups.vue?vue&type=template&id=f85e5b0e&scoped=true&"
import script from "./round-ups.vue?vue&type=script&lang=js&"
export * from "./round-ups.vue?vue&type=script&lang=js&"
import style0 from "./round-ups.vue?vue&type=style&index=0&id=f85e5b0e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85e5b0e",
  null
  
)

export default component.exports